import { authenticatedApiFetch } from './../../common/helpers';
import { isLenderPortfolioApiEnabled } from '../../common/config';
import { mapSummaryFromJson, mapInvestmentFromJson } from './lenderStatisticMappers';

export async function fetchSummary(params) {
  if (!isLenderPortfolioApiEnabled()) return {};
  const result = await authenticatedApiFetch(`lender/portfolio`, 'GET', params);
  return mapSummaryFromJson(result);
}

export async function fetchInvestmentDetail() {
  const result = await authenticatedApiFetch('user/investment')
  return mapInvestmentFromJson(result)
}
